










 

 

















const node = {
  "kind": "InlineDataFragment",
  "name": "updateLocalStage_meeting"
};

(node ).hash = "a008c6d57a0744ae660c8489fbd5f546";

export default node;
